import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { isFunction } from '../utils/ts-typeguard/is-function';

interface ApiServiceInit {
  retrySendCountDelay: number[];
  pool: RequestPool[];
}

interface Info {
  service: string;
  version: string;
  database: string;
  currentEnv: string;
}

export interface ApiRequest {
  microService: string;
  method: string;
  link: string;
  params?: any;
}

export interface RequestPool {
  param: ApiRequest;
  retryCallCount: number;
  sent: boolean;
  bridge: boolean;

  succesCalback(data: any): void;

  errorCallback(error: any): void;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  saveLogs = false;
  apiServiceInit: ApiServiceInit = {
    retrySendCountDelay: [],

    pool: [],
  };

  constructor(private http: HttpClient) {}

  public getResponseFromMicroServiceSafe2(param: ApiRequest) {
    const req: RequestPool = {
      param,
      retryCallCount: 0,
      errorCallback: () => {},
      succesCalback: () => {},
      sent: false,
      bridge: false,
    };

    return this.stratToSendRequestFromPool2(req);
  }

  public getResponseFromMicroServiceSafe(
    param: ApiRequest,
    succesCalback: any,
    errorCallback: any,
    customHeader = null
  ) {
    const req: RequestPool = {
      param,
      retryCallCount: 0,
      errorCallback,
      succesCalback,
      sent: false,
      bridge: false,
    };

    this.apiServiceInit.pool.push(req);
    const lastIndex = this.apiServiceInit.pool.length - 1;
    this.stratToSendRequestFromPool(this.apiServiceInit.pool[lastIndex], customHeader);
  }

  public getVersion(cb: any) {
    const response = this.http.get('assets/version.json?' + new Date().getTime()).pipe();

    response.subscribe((data: any) => {
      cb(data.version);
    });
  }

  private getHeader() {
    const header = new HttpHeaders().append('Content-Type', 'application/json');
    return header;
  }

  private stratToSendRequestFromPool(reqestFromPool: RequestPool, customHeader = null) {
    let response: any;
    let header = this.getHeader();
    if (customHeader) {
      header = customHeader;
    }

    switch (reqestFromPool.param.method) {
      case 'POST':
        response = this.http
          .post<any>(reqestFromPool.param.microService + reqestFromPool.param.link, reqestFromPool.param.params, {
            headers: header,
          })
          .pipe(map((res) => res));
        break;
      case 'PUT':
        const json = JSON.stringify(reqestFromPool.param.params);

        response = this.http
          .put(reqestFromPool.param.microService + reqestFromPool.param.link, json, {
            headers: header,
          })
          .pipe(map((res) => res));
        break;
      case 'DELETE':
        response = this.http
          .delete(reqestFromPool.param.microService + reqestFromPool.param.link, {
            headers: header,
          })
          .pipe(map((res) => res));
        break;

      case 'GET':
        response = this.http
          .get(reqestFromPool.param.microService + reqestFromPool.param.link, {
            headers: header,
            observe: 'response',
          })
          .pipe(map((res) => res.body));
        break;
    }
    response.subscribe(
      (data: any) => {
        this.successResponse(reqestFromPool, data);
      },
      (error: any) => {
        if (error.status === 499) {
          reqestFromPool.retryCallCount = this.apiServiceInit.retrySendCountDelay.length;

          this.errorResponse(reqestFromPool, error);
        } else {
          this.errorResponse(reqestFromPool, error);
        }
      }
    );
  }

  private stratToSendRequestFromPool2(reqestFromPool: RequestPool, customHeader = null) {
    let response: any;
    let header = this.getHeader();
    if (customHeader) {
      header = customHeader;
    }

    switch (reqestFromPool.param.method) {
      case 'POST':
        response = this.http
          .post<any>(reqestFromPool.param.microService + reqestFromPool.param.link, reqestFromPool.param.params, {
            headers: header,
          })
          .pipe(map((res) => res));
        break;
      case 'PUT':
        const json = JSON.stringify(reqestFromPool.param.params);

        response = this.http
          .put(reqestFromPool.param.microService + reqestFromPool.param.link, json, {
            headers: header,
          })
          .pipe(map((res) => res));
        break;
      case 'DELETE':
        response = this.http
          .delete(reqestFromPool.param.microService + reqestFromPool.param.link, {
            headers: header,
          })
          .pipe(map((res) => res));
        break;

      case 'GET':
        response = this.http
          .get(reqestFromPool.param.microService + reqestFromPool.param.link, {
            headers: header,
            observe: 'response',
          })
          .pipe(map((res) => res.body));
        break;
    }
    return response;
  }

  private successResponse(reqestFromPool: RequestPool, response: any) {
    reqestFromPool.sent = true;
    if (reqestFromPool.succesCalback) {
      if (reqestFromPool.bridge) {
        reqestFromPool.succesCalback(response);
      } else {
        reqestFromPool.succesCalback(response);
      }
    }
  }

  private clearPool() {
    for (let i = this.apiServiceInit.pool.length; i >= 0; i--) {
      if (this.apiServiceInit.pool[i]) {
        if (this.apiServiceInit.pool[i].sent) {
          delete this.apiServiceInit.pool[i];
        }
      }
    }
  }

  private errorResponse(reqestFromPool: RequestPool, error: any) {
    const invalidTokenError = false;
    const unexpected = true;
    if (error.error) {
    }
    if (unexpected) {
      reqestFromPool.retryCallCount++;
      if (reqestFromPool.retryCallCount > this.apiServiceInit.retrySendCountDelay.length || invalidTokenError) {
        if (isFunction(reqestFromPool.errorCallback)) {
          this.resetPool(reqestFromPool, error);
        }
      } else {
        setTimeout(() => {
          this.stratToSendRequestFromPool(reqestFromPool);
        }, this.apiServiceInit.retrySendCountDelay[reqestFromPool.retryCallCount - 1]);
      }
    }
  }

  private resetPool(reqestFromPool: RequestPool, error: any) {
    if (reqestFromPool.errorCallback) {
      reqestFromPool.sent = true;
      this.clearPool();
      if (this.saveLogs) {
      }
      reqestFromPool.errorCallback(error);
    }
  }
}
